import { render, staticRenderFns } from "./App.vue?vue&type=template&id=245c47c0&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=245c47c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c47c0",
  null
  
)

export default component.exports